import React from 'react';
import PropTypes from 'prop-types';
import {formatPrice, formatPercentage} from '~/utils/quote';

import './index.scss';

export function getSavedPercentage({originalPrice, discountPrice}) {
  if (typeof originalPrice !== 'number' || typeof discountPrice !== 'number') {
    return null;
  }
  return Math.round(
    (1 - parseFloat(discountPrice) / parseFloat(originalPrice)) * 100
  );
}

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export const MoneySavingInfo = props => {
  const {originalPrice, discountPrice} = props;

  function render() {
    if (
      typeof originalPrice !== 'number' ||
      typeof discountPrice !== 'number'
    ) {
      return null;
    }

    const savedPercentage = getSavedPercentage({
      originalPrice,
      discountPrice
    });

    return (
      <div className="ndx-MoneySavingInfo">
        <div className="ndx-MoneySavingInfo-Header">
          <span className="ndx-MoneySavingInfo-OriginalPrice">
            {formatPrice(originalPrice)}
          </span>
          <span className="ndx-MoneySavingInfo-DiscountPrice">
            {formatPrice(discountPrice)}
          </span>
          <span className="ndx-MoneySavingInfo-HeaderText">each</span>
        </div>
        <div className="ndx-MoneySavingInfo-Body">
          <div className="ndx-MoneySavingInfo-SavePercentageContainer">
            <span className="ndx-MoneySavingInfo-ExtraText">You save</span>
            <span className="ndx-MoneySavingInfo-SavedPercentage">
              {formatPercentage(savedPercentage / 100)}
            </span>
          </div>
        </div>
      </div>
    );
  }

  return render();
};

const propTypes = {
  discountPrice: PropTypes.number,
  originalPrice: PropTypes.number
};

MoneySavingInfo.propTypes = propTypes;

export default MoneySavingInfo;
